import React from 'react';

import Defaults from '../layout/Defaults.jsx';
import { FormContainer, withValidationV2 } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import { ContentContainer } from '../common/Popup.jsx';

function Component(props) {
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        contentConfig = props.config && props.config.documents && props.config.documents[PageType.Popup.Inquire];
    }
    if (!contentConfig) {
        contentConfig = Defaults.PageConfig[PageType.Popup.Inquire](props.config);
    }
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        let blockProps = {};
        switch (d.type.value) {
            case Name.Block.InquireForm.Container:
                blockProps = { editor: false, inventory: props.inventory, onLogSubscription: Logging.subscription };
                break;
            case Name.Block.Inventory.Cell.Image:
                let containerProps;
                if (props.onPageProps) {
                    containerProps = props.onPageProps();
                } else if (contentConfig.desktop) {
                    containerProps = contentConfig.desktop.page;
                }
                blockProps = { backgroundColor: Layout.backgroundColorV2(props, containerProps) };
            // Intentional fallthrough
            case Name.Block.Inventory.Cell.Text:
                if (props.inventory) {
                    blockProps.data = props.inventory;
                }
                break;
        }
        return blockProps;
    }
    return <ContentContainer {...props} blockPropsHandler={handleBlockProps} className="ol--inquire" contentConfig={contentConfig} />
}

const Logging = {
    subscription: (props) => {
        if (!window) {
            return;
        }
        const edition = InventoryHelper.edition(props.inventory);
        if (window.gtag) {
            if (!edition) {
                return;
            }
            gtag('event', 'generate_lead', { 'currency': 'USD', 'value': edition._Price })
        }
        if (window.fbq) {
            fbq('track', 'Lead');
        }
        if (window && window.pintrk) {
            if (!edition) {
                return;
            }
            pintrk('track', 'lead', {
                value: edition._Price,
                currency: 'USD',
                lead_type: 'inquiry'
            });
        }
    }
};

function _InquireFormComponent(props) {
    React.useEffect(() => {
        if (props.config && props.config.defaultInquireMessage != undefined) {
            props.onChange('Message', props.config.defaultInquireMessage);
        }

        if (!props.builder && window && window.gtag) {
            gtag('event', 'inquire-modal', {
                'title': props.inventory.title
            });
        }
    }, []);
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            AddressLineOne: props.formData.AddressLineOne,
            AddressLineTwo: props.formData.AddressLineTwo,
            City: props.formData.City,
            Country: props.formData.Country,
            Email: props.formData.Email,
            Id: props.inventory.id,
            Message: props.formData.Message,
            Name: props.formData.Name,
            Phone: props.formData.Phone,
            Price: props.formData.Price,
            Robots: props.formData.token,
            State: props.formData.State,
            Sub: props.config && props.config.subdomain,
            Zip: props.formData.Zip
        }
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        props.onSubmit('/api/contacts', postData);
    }, [props.formData.token])

    let additionalFields = [];
    const handleValidate = () => props.onValidate(additionalFields);
    const handleFormFieldProps = React.useCallback(({ blockConfig, type }, formFieldProps) => {
        switch (type) {
            case FormField.Email:
                formFieldProps.placeholderText = 'Email Address *';
                formFieldProps.type = 'email';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField[Name.Block.InquireForm.Container].ErrorMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.error = props.formData.errorMessage;
                break;
            case FormField.Message:
                formFieldProps.placeholderText = 'Your Message...';
                formFieldProps.rows = "8";
                formFieldProps.type = 'textarea';
                break;
            case FormField.Name:
                formFieldProps.placeholderText = 'Full Name *';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField.Phone:
                formFieldProps.placeholderText = 'Phone Number';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.AddressLine1:
                formFieldProps.placeholderText = 'Address Line 1';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.AddressLine2:
                formFieldProps.placeholderText = 'Address Line 2';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.City:
                formFieldProps.placeholderText = 'City';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.Country:
                formFieldProps.placeholderText = 'Country';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.State:
                formFieldProps.placeholderText = 'State';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.Zip:
                formFieldProps.placeholderText = 'Zip';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField[Name.Block.InquireForm.Container].SubmitButtonV1:
            case FormField[Name.Block.InquireForm.Container].SubmitButtonV2:
                formFieldProps.formState = props.formData.formState;
                formFieldProps.inPopup = props.inPopup;
                formFieldProps.onClick = handleValidate;
                break;
            case FormField[Name.Block.InquireForm.Container].SuccessMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.formState = props.formData.formState;
                break;
        }
    }, [props.formData.errorMessage, props.formData.formState]);

    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.design;
        } else {
            contentConfig = Defaults.Block[Name.Block.InquireForm.Container](props.config);
        }
    }
    return (
        <FormContainer.Component
            {...props}
            builder={props.builder || props.disabled}
            contentConfig={contentConfig}
            inPopup={true}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const InquireFormComponent = withValidationV2(_InquireFormComponent, ['Email', 'Message', 'Name']);
const InquireForm = { Component: InquireFormComponent };

export {
    Component,
    InquireForm
}